export default "__VITE_ASSET__vcKzPSxa__"